import React from 'react';

import ConnectionFinishedContent from './ConnectionFinishedContent';

const ConnectionFinishedDesktop = ({onOpenQsg, deviceType}) => {
    return (
        <>
            <ConnectionFinishedContent deviceType={deviceType} />
            <ConnectionFinishedContent.Buttons className='mt-8' onOpenQsg={onOpenQsg} />
        </>
    );
};

export default ConnectionFinishedDesktop;
